import React, { useEffect, useRef } from 'react';
import { animate } from 'animejs';
import './HomeLoader.css';

const LOGO_SRC = '/images/brand/logo-largo.png';

const HomeLoader = ({ onDone }) => {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const reduced =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) {
      onDone?.();
      return undefined;
    }

    const logo = root.querySelector('.home-loader-logo');
    const ring = root.querySelector('.home-loader-ring');
    const label = root.querySelector('.home-loader-label');

    const anim = animate([logo, ring, label], {
      opacity: [0, 1],
      scale: logo ? [0.92, 1] : 1,
      duration: 600,
      delay: (_, i) => i * 90,
      ease: 'outExpo',
    });

    const pulse = ring
      ? animate(ring, {
          rotate: [0, 360],
          duration: 2200,
          ease: 'linear',
          loop: true,
        })
      : null;

    const finishTimer = window.setTimeout(() => {
      animate(root, {
        opacity: [1, 0],
        duration: 420,
        ease: 'inQuad',
        onComplete: () => onDone?.(),
      });
    }, 1200);

    return () => {
      window.clearTimeout(finishTimer);
      anim.pause();
      pulse?.pause();
    };
  }, [onDone]);

  return (
    <div className="home-loader" ref={rootRef} role="status" aria-live="polite" aria-label="Cargando Javiland">
      <div className="home-loader-inner">
        <div className="home-loader-ring" aria-hidden="true" />
        <img src={LOGO_SRC} alt="Javiland" className="home-loader-logo" />
        <span className="home-loader-label">Ecosistema Javiland</span>
      </div>
    </div>
  );
};

export default HomeLoader;
